<template>
  <div
    :key="announce.id"
    ref="cardEl"
    class="client-card"
  >
    <nuxt-link class="position-relative"  :to="`/voitures/${useUrlFormat(announce.make.name)}/${useUrlFormat(announce.title)}/${announce.id}`" :key="announce.id">
      <div v-if="gridView" class="cards grid-view" :class="marketPlace.screenWidth <= breakpoints.screen_tablet ? 'cards-tab-mob':''" >
          <div class="bg-img position-relative overflow-hidden d-flex justify-content-between align-items-start p-2" :class="isHome ? 'bg-img-home' : '' ">
            <div
              class="car-preview-placeholder position-absolute top-0 start-0"
              :class="{ 'is-hidden': isImageLoaded && announce.pictures.length }"
            >
              <img
                class="car-placeholder-logo"
                :src="placeholderLogo"
                alt="Logo TopAuto"
                loading="lazy"
                decoding="async"
              />
            </div>
            <CarImage
              v-if="announce.pictures.length && shouldRenderImage"
              class="car-preview-img position-absolute top-0 start-0"
              :class="{ 'is-loaded': isImageLoaded }"
              sizes="(min-width: 1200px) 270px, (min-width: 768px) 50vw, 100vw"
              :src="announce.pictures[0].fileName!"
              :alt="announce.title || 'Photo du v\u00e9hicule'"
              :loading="priority ? 'eager' : 'lazy'"
              :fetchpriority="priority ? 'high' : 'low'"
              :preload="priority"
              @loaded="onImageLoaded"
            />
            <div
              v-if="showPromotionBadge || announce.pictures.length"
              class="card-badges d-flex justify-content-between align-items-start w-100 position-absolute top-0 start-0 p-2"
            >
              <span
                v-if="showPromotionBadge"
                class="badge rounded badge-sponsor d-flex justify-content-center align-items-center text-warning-600 fsz-11 fw-bold px-2"
              >
                <i class="material-symbols-rounded fsz-14 me-1">star</i>
                Boostée
              </span>
              <div
                v-if="announce.pictures.length"
                class="carNbImg bg-black rounded d-flex justify-content-center align-items-center"
              >
                <span v-if="hasStatus" class="d-flex fsz-11 fw-normal text-white">
                  <i class="material-symbols-rounded fsz-16" style="margin-right: 2px;">image</i>
                  <span>{{ picturesCount }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="card-head d-flex flex-column gap-2">
            <!-- <div v-if="announce.status && hasStatus">
              <span v-if="announce.status === 'TO_SELL'" class="badge badge-for-sale rounded-pill-badge-sm text-success-600 bg-success-25 fsz-11 fw-normal">
                À Vendre
            </span> 
            <span v-else-if="announce.status === 'SOLD'" class="badge rounded-pill-badge-sm text-danger-600 bg-danger-25 fsz-11 fw-normal">
                Vendue
            </span>
             <span v-else-if="announce.status === 'DRAFT'" class="badge rounded-pill-badge-sm text-gray-600 bg-gray-25 fsz-11 fw-normal">
                Brouillon
            </span> 
            <span v-else-if="announce.status === 'ARCHIVED'" class="badge rounded-pill-badge-sm  bg-danger-600 fsz-11 fw-normal">
                Archivée
            </span> 
            </div> -->
            
          </div>
          <div class="card-body ">
            <ul class="card-list">
              <li v-if="announce.make.name && announce.model.name && announce.bodyType" 
                  class="list-group-item model d-flex align-items-baseline" :class="!isHome && width < breakpoints.screen_smallMobile ? 'pb-2' : 'pb-1'" :style="{'line-height': !isHome && width < breakpoints.screen_smallMobile ? '1.4' :''}">
                <span :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-18' : 'title-limitation announceTitle fsz-16'"
                  v-tippy="{ content: `${announce.make.name} ${announce.model.name} ${announce.bodyType}` }">
                  
                  <span class="fw-semibold">{{ announce.make.name }} {{ announce.model.name }}</span> 
                  {{ ' ' + announce.bodyType }}
                  
                </span>
              </li>
              <li class="list-group-item model d-flex align-items-baseline pb-2">
                <div class="d-flex align-items-start gap-2">
                  <span class="title-limitation announceTitle" style="font-weight: 900;" :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-18' : 'fsz-16'">
                    {{ usePriceFormat(announce.price) }} DT
                  </span>
                    <span v-if="announce.priceNegotiable" :class="isHome && width < breakpoints.screen_smallMobile ? 'd-none' : ''"
                      class="d-flex gap-1 align-items-center badge badge-negotiable rounded-pill-badge bg-success-100 text-success-700 fsz-10 fw-normal px-2">
                      <i class="material-symbols-rounded fsz-14">swap_horiz</i>
                      Négociable
                    </span>
                </div>
              </li>
              <li class="list-group-item model d-flex align-items-baseline"
                :class="!isHome && width < breakpoints.screen_smallMobile ? 'pb-3' : 'pb-2'">
                <ul class="car-details d-flex m-0 p-0" :class="isHome || (!isHome && width >= breakpoints.screen_smallMobile) ? 'detail' : ''">
                  <li v-if="hasCarDetail(announce.kilometers)" class="option pe-1" :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-14' : 'fsz-12'">
                    {{ usePriceFormat(announce.kilometers) }} km
                  </li>
                  <li v-if="hasCarDetail(announce.fuelType)" class="option pe-1" :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-14' : 'fsz-12'">
                    {{ announce.fuelType }}
                  </li>
                  <li v-if="hasCarDetail(announce.transmission)" class="option pe-1" :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-14' : 'fsz-12'">
                    {{ announce.transmission }}
                  </li>
                  <li v-if="hasCarDetail(announce.registrationYear)" class="option pe-1" :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-14' : 'fsz-12'">
                    {{ announce.registrationYear }}
                  </li>
                </ul>
              </li>
              <li class="list-group-item model d-flex align-items-center gap-1"
                  :class="width < breakpoints.screen_laptop ? 'border-top pt-2' : '' "
                  v-if="announce.city && announce.address">
                <i class="material-symbols-rounded" :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-16' : 'fsz-14'">place</i>
                <span :class="!isHome && width < breakpoints.screen_smallMobile ? 'fsz-14' : 'fsz-12 title-limitation announceTitle'"
                  v-tippy="{ content: `${announce.city} ${announce.address}` }">
                  {{ announce.city }}, {{ announce.address }}
                </span>
              </li>
            </ul>
          </div>
    
  
        <!-- <div v-if="isMarketP" class="cards-footer  d-flex justify-content-between align-items-center">
          <nuxt-link class="btn details-link text-primary-600 fw-semiBold p-0" :to="`/voitures/${useUrlFormat(announce.make.name)}/${useUrlFormat(announce.title)}/${announce.id}`" >
            <component :is="icons.arrow" class="d-18"></component>
      
            Voir l’annonce
          </nuxt-link> -->
          <!-- <button class="options-button">
              <component :is="icons.threeDots" class="d-30 me-0"></component>
            </button> -->
        <!-- </div> -->
        <div v-if="width > breakpoints.screen_laptop" class="cards-footer d-flex justify-content-between">
  <!-- Lien détails -->
  <nuxt-link 
    class="d-flex align-items-center gap-2 details-link" 
    :to="`/voitures/${useUrlFormat(announce.make.name)}/${useUrlFormat(announce.title)}/${announce.id}`">
    <i class="material-symbols-rounded fsz-20">arrow_forward</i>
    Voir Détails
  </nuxt-link>

  <!-- Bouton heart dans un cadre carré -->
  <div v-if="width > breakpoints.screen_smallMobile" class="d-flex align-items-center">
  <button 
    v-if="(!announce.saved && (dashStore.getUserProfil?.id != announce.userId))" 
    class="save-link d-flex align-items-center justify-content-center border border-1 rounded-3 bg-white shadow-sm"
    style="width: 32px; height: 32px;"  
    @click.prevent="save(announce.id)"
    v-show="!saveParams.saved"
    aria-label="Enregistrer cette annonce dans vos favoris"
  >
    <!-- Spinner si en attente -->
    <div 
      v-if="dashStore.getPendingStats.saveAnnounce && saveParams.clickedAnnounce" 
      class="spinner-border text-primary-600 spinner-border-sm" 
      role="status">
    </div> 

    <!-- Icône cœur -->
    <i 
      v-else 
      class="material-icons-round fsz-18 text-primary-600"
      :class="!saveParams.saved ? '' : 'text-primary-600'"
    >{{ !saveParams.saved ? 'favorite_border' : 'favorite' }}</i>
  </button>
</div>

</div>

  
      </div>
      <div v-else class="cards row-view" >
        <div class="row g-0">
          <div class="col-md-4">
            <div class="bg-img position-relative overflow-hidden py-0">
              <div
                class="car-preview-placeholder position-absolute top-0 start-0"
                :class="{ 'is-hidden': isImageLoaded && announce.pictures.length }"
              >
                <img
                  class="car-placeholder-logo"
                  :src="placeholderLogo"
                  alt="Logo TopAuto"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <CarImage
                v-if="announce.pictures.length && shouldRenderImage"
                class="car-preview-img w-100 h-100 object-fit-cover"
                :class="{ 'is-loaded': isImageLoaded }"
                v-bind:src="announce.pictures[0].fileName!"
                :alt="announce.title || 'Photo du véhicule'"
                :loading="priority ? 'eager' : 'lazy'"
                :fetchpriority="priority ? 'high' : 'low'"
                :preload="priority"
                @loaded="onImageLoaded"
              />
              <div
                v-if="showPromotionBadge || announce.pictures.length"
                class="card-badges d-flex justify-content-between align-items-start w-100 position-absolute top-0 start-0 p-2"
              >
                <span
                  v-if="showPromotionBadge"
                  class="badge rounded badge-sponsor text-warning-600 d-flex justify-content-center align-items-center fsz-11 fw-bold px-2 py-1"
                >
                  <i class="material-symbols-rounded fsz-14 me-1">star</i>
                  Boostée
                </span>
                <div v-if="announce.pictures.length" class="carNbImg bg-black rounded d-flex justify-content-center align-items-center" >
                  <span v-if="hasStatus" class="d-flex fsz-11 fw-normal text-white">
                    <i class="material-symbols-rounded fsz-16" style="margin-right: 2px;">image</i>
                    <span>{{ picturesCount }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="card-head d-flex justify-content-between gap-2">
            
              <h4 class="fw-medium col-8 p-0 title-limitation"
                v-tippy="{ content: announce.title }">
                {{ announce.title }}
              </h4>
              <h4 class="text-end col-4 p-0" style="font-weight: 900; letter-spacing: -1px;">
                {{ usePriceFormat(announce.price) }} DT
              </h4>
            </div>
            <div class="card-body d-flex justify-content-between">
              <ul class="card-list col-9">
                <li class="list-group-item d-flex gap-2" v-if="announce.address">     
                    <i class="material-symbols-rounded fsz-20">place</i>
                    <span class="title-limitation"
                      v-tippy="{ content: `${announce.city}, ${announce.address}` }">
                      {{ announce.city }}, {{ announce.address }}
                    </span>
                </li>
                <ul class="m-0 car-features row row-cols-2 flex-column">
                  <li v-if="hasCarDetail(announce.kilometers)" class="list-group-item d-flex gap-2">
                    <i class="material-symbols-rounded fsz-20">speed</i>
                    {{ usePriceFormat(announce.kilometers) }} km
                  </li>
                  <li v-if="hasCarDetail(announce.transmission)" class="list-group-item d-flex gap-2">
    
                    <i class="material-symbols-rounded fsz-20">auto_transmission</i>
                    {{ announce.transmission }}
                  </li>
                  <li v-if="hasCarDetail(announce.registrationYear)" class="list-group-item d-flex gap-2">
    
                    <i class="material-symbols-rounded fsz-20">calendar_today</i>
                    {{ announce.registrationYear }}
                  </li>
                  <li v-if="hasCarDetail(announce.fuelType)" class="list-group-item d-flex gap-2">
    
                    <i class="material-symbols-rounded fsz-20">local_gas_station</i>
                    {{ announce.fuelType }}
                  </li>
                </ul>
    
    
              </ul>
              <div class="d-flex flex-column align-items-end gap-2">
                <span v-if="announce.priceNegotiable" 
                  class="priceNgc d-flex align-items-center gap-1 badge badge-negotiable rounded-pill-badge bg-success-100 text-success-700 fsz-12 fw-normal px-2 py-1">
                  <i class="material-symbols-rounded fsz-18">swap_horiz</i>
                  <span>Négociable</span>
                </span>
              </div>
              <!-- <div class="col-3">
                <p class="fsz-12 fw-semiBold text-gray-900">
                  Très bon prix
                </p>
                <div class="progress ">
                  <div class="progress-bar progress-bar-success-700" role="progressbar" aria-label="Basic example"
                    style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div> -->
            </div>
            <div class="cards-footer  d-flex justify-content-between align-items-end">
              <nuxt-link  class="d-flex align-items-center gap-2 details-link" :to="`/voitures/${useUrlFormat(announce.make.name)}/${useUrlFormat(announce.title)}/${announce.id}`">
                <i class="material-symbols-rounded fsz-20">arrow_forward</i>
    
                Voir Détails
              </nuxt-link>
    
              <button v-if="(!announce.saved && (dashStore.getUserProfil?.id != announce.userId))" class="d-flex gap-2 align-items-center btn save-link p-0"  v-show="!saveParams.saved"
              @click.prevent=" save(announce.id) ">
                <div v-if="dashStore.getPendingStats.saveAnnounce && saveParams.clickedAnnounce" class="spinner-border text-primary-600" role="status">
                                        
                </div> 
                      <i v-else class="material-icons-outlined fsz-18">favorite_border</i>
    
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      </div>
    </nuxt-link>
    


    <Dialog 
    v-model:visible="saveDialog"  
    dismissableMask
    modal 
    :pt="{
      header:{
        class : 'flex-row-reverse , pb-0'
      },
      mask: {
        style: 'backdrop-filter: blur(2px)'}  
    }"
    :style="{ width: '500px' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="text-center ">
        <h4 class="mb-2">
          Veuillez vous connecter pour enregistrer un véhicule
        </h4>
        <p>
          Utilisez votre identifiant Top Auto pour vous connecter
        </p>
        <nuxt-link  class="btn btn-solid-primary-600 mt-5" to="/authentication/login">
          Connexion
        </nuxt-link>
        <p class="py-3 fsz-12 text-gray-900 text-center">
          Vous n’avez pas de compte ?
          <nuxt-link class="simple-link text-primary-400" to="/authentication/signup">Créer un compte</nuxt-link>
      </p>
      </div>
  
  </Dialog>
  </div>


 
</template>

<script setup lang="ts">
import { useToast } from "primevue/usetoast";
import { breakpoints } from "~/utils/breakpoints";
import { getAnnouncementPicturesCount } from "~/utils/announcementPictures";

const toast = useToast();
const saveDialog = ref(false);
const { width } = useWindowSize();
const marketPlace = useMarketPlace();
const dashStore = useDashboardStore();
const runtimeConfig = useRuntimeConfig();
const { trackAddToWishlist } = useMetaPixel();
const placeholderLogo = new URL('../../assets/images/logos/Logo-Empty.svg', import.meta.url).href;
const loadedCardImages = useState<Record<string, boolean>>('loaded-card-images', () => ({}));
const props = defineProps({
  announce: { type: Object , required : true , default : {}},
  className: { type: String , default: ''},
  gridView : {type : Boolean , default : false},
  hasStatus : {type : Boolean , default : false },
  isDash : {type : Boolean , default : false},
  isHome : {type : Boolean , default : false},
  isMarketP : {type : Boolean , default : false},
  priority : {type : Boolean , default : false},
})

const imageKey = computed(() => String(props.announce.id));
const isImageLoaded = ref(loadedCardImages.value[imageKey.value] || false);

const shouldRenderImage = ref(
  !process.client || props.priority || loadedCardImages.value[imageKey.value]
);

const saveParams = reactive({
  saved : props.announce.saved || false,
  clickedAnnounce : 0
})
const cardEl = ref<HTMLElement | null>(null);
const promotionInfo = computed(() => {
  const announce = props.announce as any;
  if (!announce) return null;
  if (announce.promotion) return announce.promotion;
  if (typeof announce.isPromoted === 'boolean') {
    return { isPromoted: announce.isPromoted, promotedAt: announce.promotedAt };
  }
  return null;
});
const showPromotionBadge = computed(() => {
  const promotion = promotionInfo.value;
  if (!promotion) return false;
  if (typeof promotion.isPromoted === 'boolean') return promotion.isPromoted;
  return false;
});
const picturesCount = computed(() => getAnnouncementPicturesCount(props.announce));
const hasCarDetail = (value: unknown) => {
  if (typeof value === 'string') return value.trim().length > 0;
  return true;
};
const displayDetail = (value: unknown) => {
  if (value === null || value === undefined) return 0;
  return value;
};

const { stop: stopObservingCard } = useIntersectionObserver(cardEl, ([entry]) => {
  if (entry.isIntersecting) {
    shouldRenderImage.value = true;
    stopObservingCard();
  }
}, { threshold: 0 });

const onImageLoaded = () => {
  isImageLoaded.value = true;
  loadedCardImages.value[imageKey.value] = true;
};
const showToast = (severity: any, summary: string, detail: string) => {
  toast.add({
    severity: severity,
    summary: summary,
    detail: detail,
    life: 3000
  });
};

const save = async (id: number) => {
  if (!dashStore.getIsUserConnected) {
    saveDialog.value = true;
    return;
  }

  // capture clicked annonce 
  saveParams.clickedAnnounce = id;

  try {
    // Si l'annonce était déjà sauvegardée -> unsave
    if (saveParams.saved) {
      await dashStore.UnsaveAnnounce(id);
      saveParams.saved = false;
      props.announce.saved = false;
      showToast('info', 'Annonce retirée', 'Votre annonce a été retirée de vos favoris.');
    } else {
      await dashStore.saveAnnounce(id);
      saveParams.saved = true;
      props.announce.saved = true;
      if (
        runtimeConfig.public.clientBaseUrl === 'https://topauto.tn' &&
        showPromotionBadge.value
      ) {
        trackAddToWishlist(String(id), {
          vehicle: props.announce,
          page_name: 'Listing Card',
          page_type: 'search_listing',
          locale: 'fr-TN',
        });
      }
      showToast('success', 'Annonce enregistrée', 'Votre annonce a été enregistrée avec succès.');
    }

  } catch (e) {
    showToast('error', 'Erreur', 'Une erreur est survenue. Veuillez réessayer.');
  } finally {
    saveParams.clickedAnnounce = 0;
  }
};

</script>

<style lang="scss" scoped>
.cards-tab-mob{
  max-width: 100%;
}
.carNbImg{
  min-width: 20px;
  height: 20px;
  padding: 2px 4px;
  opacity: 0.65;
  z-index: 2;
}
.card-badges{
  z-index: 2;
}
.card-badges .carNbImg{
  margin-left: auto;
}
.car-preview-img{
  width: 100%;
  height: 100%;
  display: block;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.6s ease-in-out;
  z-index: 1;
}
.car-preview-img--bg-fallback{
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.car-preview-img.is-loaded{
  opacity: 1;
}
.car-preview-placeholder{
  width: 100%;
  height: 100%;
  aspect-ratio: 4 / 3;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.6s ease-in-out;
}
.car-preview-placeholder.is-hidden{
  opacity: 0;
}
.car-placeholder-logo{
  width: 56px;
  height: 56px;
  object-fit: contain;
}
.priceNgc{
  margin-top: -12px;
}
.bg-img-home{
  min-height: 190px !important;
}
.car-details{
  flex-wrap: wrap;
}
.detail{
  min-height: calc(1em * 2.8);
  line-height: 1.4em;
}
.option {
  display: inline-block;
  white-space: nowrap;

  &::after {
    content: "|";
    padding-left: 4px;
  }

  &:last-child::after {
    content: "";
  }
}


</style>
